module.exports = __webpack_public_path__ + "img/saveIcon.48079624.svg";